import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22 7.638h-2V4.05H4v14.865l3.8-2.256 1 1.743L5 20.657c-.9.615-2.1.308-2.7-.717-.2-.308-.3-.615-.3-1.025V4.05C2 2.923 2.9 2 4 2h16c1.1 0 2 .923 2 2.05v3.588zm-2 1.538c1.1 0 2 .922 2 2.05v9.739c0 .307-.1.717-.3 1.025-.5.923-1.7 1.333-2.7.718l-3.8-2.256H12c-1.1 0-2-.922-2-2.05v-7.176c0-1.128.9-2.05 2-2.05h8zm0 2.05h-8v7.176h3.2c.3 0 .7.103 1 .308l3.8 2.255v-9.739z"
    />
  </svg>
);
